import PressClassificationContainer from "@/components/business/PressClassificationContainer/PressClassificationContainer";
import DeletedPressBoundary from "@/components/shared/business/DeletedPressBoundary/DeletedPressBoundary";
import { useSafeLeavePage } from "@hooks/useSafeLeavePage";

const PressClassificationPage = () => {
  useSafeLeavePage();

  return (
    <DeletedPressBoundary>
      <PressClassificationContainer />
    </DeletedPressBoundary>
  );
};

export default PressClassificationPage;
